export const page: string[] = ['eq-control-plan', 'download'];